import Confirm from './confirm';

import Alert from './alert';

export default {
  install(instance: any) {
    /* eslint-disable no-param-reassign */
    instance.prototype.confirm = (msg: string,
      options?: any) => new Confirm(instance).install(msg, options);
    instance.prototype.alert = (msg: string,
      options?: any) => new Alert(instance).install(msg, options);
  },
};
